import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.35 7.08a.86.86 0 0 0 0-.16 4.11 4.11 0 0 0-4.1-4.11 4.06 4.06 0 0 0-3.9 2.86 3.5 3.5 0 0 0 .41 7H12a2.79 2.79 0 0 0 .4-5.56ZM12 11.14H4.76a2 2 0 1 1 0-4h.19a.82.82 0 0 0 .3-.07.72.72 0 0 0 .23-.17.75.75 0 0 0 .07-.12.57.57 0 0 0 .07-.22s0 0 0-.06a2.58 2.58 0 0 1 2.64-2.19 2.61 2.61 0 0 1 2.6 2.61 2.55 2.55 0 0 1-.1.72.77.77 0 0 0 .51.93h.06a.83.83 0 0 0 .35 0h.27a1.3 1.3 0 0 1 0 2.59ZM5.29 7.05a.71.71 0 0 1-.41.09h.11a.82.82 0 0 0 .3-.09Z';
const draw24px =
  'M18.81,11.39a6.38,6.38,0,0,0-6.37-7.18A6.37,6.37,0,0,0,6.23,9a5.39,5.39,0,0,0,.29,10.78H18.68a4.2,4.2,0,0,0,.13-8.4Zm-.13,6.9H6.52a3.9,3.9,0,0,1,0-7.8h.26a1,1,0,0,0,.36-.06.81.81,0,0,0,.18-.12A.74.74,0,0,0,7.54,10l0-.13s0-.07,0-.1v0a4.93,4.93,0,0,1,9.77.88A5.08,5.08,0,0,1,17.17,12a.71.71,0,0,0,.41.88.24.24,0,0,0,.1.05h0a.77.77,0,0,0,.4,0,2.73,2.73,0,0,1,3.28,2.65A2.7,2.7,0,0,1,18.68,18.29ZM7.59,9.77v0a.59.59,0,0,1,0,.19l0-.13S7.58,9.8,7.59,9.77Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CloudIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'cloud'),
) as IconWithRender;

CloudIcon.displayName = 'CloudIcon';
CloudIcon.propTypes = Icon.propTypes;
CloudIcon.renderIcon = (props) => <CloudIcon {...props} />;
export default CloudIcon;
